import { MenuModel } from '../../types'

// localeTextName - это ключ, который мы передаем в функцию "t" из библиотека react-i18next, чтобы отобржать язык в завимисти, что выбрал польльзователь
export const menuLinks: MenuModel[] = [
  {
    name: 'Orders ',
    link: '/orders',
    icon: 'orders',
    localeTextName: 'Orders',
    requiredPermission: 'get order list',
    subLinks: [
      { name: 'Список', link: '/orders', localeTextName: 'list' },
      { name: 'Розница', link: '/retail', localeTextName: 'retail' },
      { name: 'Возвраты', link: '/returns', localeTextName: 'returns' },
      { name: 'Отчёты', link: '/reports', localeTextName: 'reports' },
      { name: 'Покупатели', link: '/customers', localeTextName: 'customers' },
      { name: 'FBO', link: '/fbo', localeTextName: 'fbo' },
      {
        name: 'Брошенные корзины',
        link: '/abandoned',
        localeTextName: 'abandoned',
      },
    ],
  },
  {
    name: 'Products',
    link: '/products',
    icon: 'list_alt',
    localeTextName: 'products',
    requiredPermission: 'get product list',
    subLinks: [
      { name: 'Список', link: '/products', localeTextName: 'list' },
      { name: 'Опции', link: '/options', localeTextName: 'options' },
      {
        name: 'Категории',
        link: '/categories',
        localeTextName: 'categories',
      },
      {
        name: 'Материалы',
        link: '/materials',
        localeTextName: 'materials',
      },
      {
        name: 'Особенности',
        link: '/feature',
        localeTextName: 'feature',
      },
      { name: 'Отзывы', link: '/reviews', localeTextName: 'reviews' },
      { name: 'Значки', link: '/badges', localeTextName: 'badges' },
      { name: 'Кванты', link: '/kvants', localeTextName: 'kvants' },
      { name: 'Комплекты', link: '/kits', localeTextName: 'kits' },
    ],
  },
  {
    name: 'Store',
    link: '/stores',
    icon: 'stores',
    localeTextName: 'Store',
    requiredPermission: 'get store list',
    subLinks: [
      { name: 'list', link: '/stores', localeTextName: 'list' },
      { name: 'brands', link: '/brands', localeTextName: 'brands' },
      {
        name: 'settings-shipping',
        link: '/settings-shipping',
        localeTextName: 'settingShipping',
      },
      {
        name: 'Информационные страницы',
        link: '/information',
        localeTextName: 'infomationPages',
      },
      {
        name: 'posts',
        link: '/blog/posts',
        localeTextName: 'posts',
      },
      {
        name: 'tags',
        link: '/blog/tags',
        localeTextName: 'tags',
      },
      { name: 'activity', link: '/activity', localeTextName: 'logs' },
    ],
  },
  {
    name: 'warehouse',
    link: '/incoming',
    icon: 'warehouse',
    localeTextName: 'warehouse',
    requiredPermission: 'get incoming list',
    indicatorKey: 'express',
    subLinks: [
      { name: 'Поступление', link: '/incoming', localeTextName: 'entrance' },
      {
        name: 'Сборка',
        link: '/assembly/orders',
        localeTextName: 'assembly',
        badgeKey: 'assembly',
        indicatorKey: 'express',
      },
      {
        name: 'Инвентаризация',
        link: '/inventory',
        localeTextName: 'inventory',
      },
      {
        name: 'Автозакупки',
        link: '/autopurchases',
        localeTextName: 'autopurchases',
      },
      { name: 'Закупка', link: '/purchase', localeTextName: 'purchase' },
      {
        name: 'Отправка',
        link: '/shipping/orders',
        localeTextName: 'dispatch',
        badgeKey: 'dispatch',
      },
    ],
  },
  {
    name: 'marketing',
    link: '/discounts',
    icon: 'marketing',
    localeTextName: 'marketing',
    requiredPermission: 'get sale list',
    subLinks: [
      { name: 'Скидки', link: '/discounts', localeTextName: 'discounts' },
      { name: 'Купоны', link: '/coupons', localeTextName: 'coupons' },
      { name: 'Слайдер', link: '/slider', localeTextName: 'slider' },
    ],
  },
  {
    name: 'Производство',
    link: '/production/route-sheets',
    icon: 'production',
    localeTextName: 'production',
    requiredPermission: 'get production list',
    subLinks: [
      {
        name: 'Маршрутные листы',
        link: '/production/route-sheets',
        localeTextName: 'productionRouteSheets',
      },
      {
        name: 'Межоперационная работа',
        link: '/production/interoperation',
        localeTextName: 'productionInteroperation',
        requiredPermission: 'assign production route sheet',
      },
      {
        name: 'Сроки и аналитика',
        link: '/production/analytics',
        localeTextName: 'productionAnalytics',
      },
      {
        name: 'Сотрудники и цеха',
        link: '/production/employees',
        localeTextName: 'productionEmployees',
      },
      {
        name: 'База Честных знаков',
        link: '/production/honest-signs',
        localeTextName: 'productionHonestSigns',
      },
    ],
  },
  {
    name: 'Себестоимость',
    link: '/costing/products',
    icon: 'list_alt',
    localeTextName: 'costing',
    requiredPermission: 'get costing list',
    subLinks: [
      {
        name: 'Изделия',
        link: '/costing/products',
        localeTextName: 'costingProducts',
      },
      {
        name: 'Материалы',
        link: '/costing/materials',
        localeTextName: 'costingMaterials',
      },
      {
        name: 'Операции',
        link: '/costing/operations',
        localeTextName: 'costingOperations',
      },
      {
        name: 'Поставщики',
        link: '/costing/suppliers',
        localeTextName: 'costingSuppliers',
      },
    ],
  },
  {
    name: 'Финансы',
    link: '/finance/payroll',
    icon: 'finance',
    localeTextName: 'finance',
    requiredPermission: 'view payroll',
    subLinks: [
      {
        name: 'Расчёт зарплаты',
        link: '/finance/payroll',
        localeTextName: 'payroll',
      },
    ],
  },
]

export const iconMenuLinks = [
  { link: '/settings', icon: 'settings' },
  { link: '/orders', icon: 'orders' },
  { link: '/incoming', icon: 'warehouse' },
]
